declare namespace $ {

	export class $shm_hitalama_map_widget_float_table_resize extends $mol_view {
		start( next?: any ): any
		move( next?: any ): any
		end( next?: any ): any
		suppress( next?: any ): any
		width( next?: number ): number
		attr( ): ({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['start'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['start'] >,
			pointermove( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['move'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['move'] >,
			pointerup( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] >,
			pointercancel( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] >,
			lostpointercapture( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['end'] >,
			click( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['suppress'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['suppress'] >,
			dblclick( next?: ReturnType< $shm_hitalama_map_widget_float_table_resize['suppress'] > ): ReturnType< $shm_hitalama_map_widget_float_table_resize['suppress'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
}

//# sourceMappingURL=resize.view.tree.d.ts.map